/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SubmitUtilityVerificationResponseDTO = {
    bvnJobId?: string;
    jobId?: string;
    message?: string;
    selfieJobId?: string;
    verificationType?: SubmitUtilityVerificationResponseDTO.verificationType;
};

export namespace SubmitUtilityVerificationResponseDTO {

    export enum verificationType {
        BVN_VERIFICATION = 'BVN_VERIFICATION',
        SELFIE_VERIFICATION = 'SELFIE_VERIFICATION',
        COMBINED_VERIFICATION = 'COMBINED_VERIFICATION',
    }


}
